var map = {
	"./cap-brazil.png": 436,
	"./cap-china.png": 437,
	"./cap-greece.png": 438,
	"./cap-sri-lanka.png": 439,
	"./hat-brazil.png": 440,
	"./hat-china.png": 441,
	"./hat-greece.png": 442,
	"./hat-sri-lanka.png": 443,
	"./special-adventour.png": 444,
	"./special-crown.png": 445,
	"./special-indiana.png": 446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 449;